const CecaPt = (props) => {
    return (
        <svg
            version="1.0"
            xmlns="http://www.w3.org/2000/svg"
            width="141.73px"
            height="36.852px"
            viewBox="0 0 141.73 36.852"
            {...props}
        >
            <g>
                <g>
                    <g>
                        <g>
                            <path
                                fill="#E90E8A"
                                d="M18.535,35.401c-6.994,0-13.37-4.389-15.864-10.919c-0.526-1.379,0.165-2.923,1.542-3.448
                    c1.379-0.527,2.925,0.163,3.449,1.541c1.709,4.479,6.079,7.486,10.874,7.486c3.484,0,6.756-1.545,8.978-4.237
                    c0.938-1.136,2.621-1.296,3.761-0.359c1.138,0.94,1.299,2.623,0.358,3.763C28.393,33.151,23.62,35.401,18.535,35.401z"
                            />
                            <path
                                fill="#E90E8A"
                                d="M5.165,15.996c-0.315,0-0.638-0.057-0.951-0.178c-1.379-0.525-2.069-2.069-1.543-3.447
                    c2.495-6.533,8.87-10.922,15.864-10.922c5.133,0,9.938,2.29,13.18,6.278c0.931,1.145,0.758,2.826-0.389,3.756
                    c-1.143,0.929-2.827,0.757-3.758-0.387c-2.221-2.735-5.514-4.306-9.033-4.306c-4.795,0-9.165,3.007-10.874,7.485
                    C7.255,15.341,6.242,15.996,5.165,15.996z"
                            />
                        </g>
                        <path
                            fill="#E90E8A"
                            d="M14.018,18.427c0,2.454,1.998,4.45,4.449,4.45c2.457,0,4.453-1.997,4.453-4.45
                c0-2.455-1.996-4.453-4.453-4.453C16.015,13.973,14.018,15.971,14.018,18.427z"
                        />
                    </g>
                </g>
                <g>
                    <path
                        fill="#222324"
                        d="M38.379,9.748V9.709c0-3.868,2.896-7.036,7.016-7.036c2.099,0,3.479,0.621,4.665,1.535
            c0.253,0.194,0.467,0.525,0.467,0.953c0,0.66-0.525,1.166-1.186,1.166c-0.33,0-0.563-0.116-0.719-0.233
            c-0.933-0.758-1.944-1.224-3.247-1.224c-2.585,0-4.489,2.138-4.489,4.8v0.039c0,2.663,1.885,4.82,4.489,4.82
            c1.439,0,2.411-0.467,3.402-1.302c0.175-0.155,0.427-0.273,0.719-0.273c0.602,0,1.127,0.506,1.127,1.108
            c0,0.37-0.175,0.661-0.389,0.855c-1.283,1.128-2.741,1.828-4.937,1.828C41.334,16.744,38.379,13.655,38.379,9.748z"
                    />
                    <path
                        fill="#222324"
                        d="M52.336,9.748V9.709c0-3.829,2.954-7.036,7.133-7.036s7.093,3.167,7.093,6.997v0.039
            c0,3.828-2.953,7.036-7.132,7.036C55.251,16.744,52.336,13.576,52.336,9.748z M64.055,9.748V9.709
            c0-2.643-1.924-4.839-4.625-4.839c-2.703,0-4.587,2.157-4.587,4.8v0.039c0,2.643,1.924,4.82,4.625,4.82
            C62.17,14.529,64.055,12.391,64.055,9.748z"
                    />
                    <path
                        fill="#222324"
                        d="M69.461,4.033c0-0.661,0.524-1.205,1.206-1.205h0.252c0.523,0,0.874,0.272,1.107,0.641l4.121,6.453
            l4.139-6.472c0.253-0.408,0.604-0.622,1.089-0.622h0.253c0.679,0,1.204,0.544,1.204,1.205v11.39c0,0.661-0.525,1.185-1.204,1.185
            c-0.642,0-1.187-0.544-1.187-1.185V7.26l-3.323,4.995c-0.254,0.389-0.564,0.622-1.011,0.622c-0.428,0-0.737-0.233-0.991-0.622
            l-3.304-4.957v8.145c0,0.661-0.524,1.166-1.185,1.166c-0.661,0-1.167-0.505-1.167-1.166V4.033z"
                    />
                    <path
                        fill="#222324"
                        d="M86.332,4.111c0-0.681,0.524-1.205,1.205-1.205h4.16c3.188,0,5.169,1.808,5.169,4.547v0.04
            c0,3.051-2.448,4.645-5.442,4.645h-2.701v3.285c0,0.661-0.524,1.185-1.186,1.185c-0.681,0-1.205-0.524-1.205-1.185V4.111z
            M91.502,9.981c1.809,0,2.936-1.011,2.936-2.429V7.512c0-1.594-1.147-2.429-2.936-2.429h-2.779v4.897H91.502z"
                    />
                    <path
                        fill="#222324"
                        d="M97.451,14.956l5.054-11.273c0.272-0.603,0.758-0.972,1.438-0.972h0.117c0.681,0,1.146,0.369,1.419,0.972
            l5.054,11.273c0.096,0.175,0.135,0.349,0.135,0.505c0,0.642-0.485,1.146-1.127,1.146c-0.563,0-0.952-0.331-1.167-0.836
            l-1.107-2.545h-6.607l-1.147,2.624c-0.194,0.486-0.602,0.757-1.107,0.757c-0.621,0-1.108-0.486-1.108-1.108
            C97.295,15.325,97.354,15.151,97.451,14.956z M106.352,11.108l-2.391-5.5l-2.391,5.5H106.352z"
                    />
                    <path
                        fill="#222324"
                        d="M113.254,4.111c0-0.681,0.525-1.205,1.204-1.205h4.86c1.711,0,3.051,0.505,3.927,1.36
            c0.718,0.738,1.126,1.75,1.126,2.935V7.24c0,2.177-1.264,3.499-3.09,4.062l2.604,3.286c0.233,0.291,0.389,0.543,0.389,0.913
            c0,0.661-0.564,1.108-1.146,1.108c-0.545,0-0.895-0.252-1.167-0.622l-3.304-4.218h-3.013v3.655c0,0.661-0.524,1.185-1.187,1.185
            c-0.679,0-1.204-0.524-1.204-1.185V4.111z M119.141,9.65c1.712,0,2.8-0.894,2.8-2.273V7.338c0-1.458-1.05-2.254-2.817-2.254
            h-3.479V9.65H119.141z"
                    />
                    <path
                        fill="#222324"
                        d="M127.307,15.305V4.111c0-0.681,0.525-1.205,1.205-1.205h7.91c0.583,0,1.068,0.486,1.068,1.069
            c0,0.602-0.485,1.069-1.068,1.069h-6.726v3.537h5.852c0.583,0,1.068,0.486,1.068,1.088c0,0.583-0.485,1.049-1.068,1.049h-5.852
            v3.654h6.824c0.582,0,1.068,0.486,1.068,1.069c0,0.602-0.486,1.068-1.068,1.068h-8.009
            C127.833,16.511,127.307,15.986,127.307,15.305z"
                    />
                </g>
                <g>
                    <path
                        fill="#222324"
                        d="M39.344,32.347V21.153c0-0.681,0.525-1.205,1.206-1.205h7.91c0.583,0,1.069,0.485,1.069,1.068
            c0,0.603-0.486,1.068-1.069,1.068h-6.725v3.538h5.851c0.583,0,1.069,0.486,1.069,1.088c0,0.583-0.486,1.05-1.069,1.05h-5.851
            v3.654h6.822c0.583,0,1.069,0.485,1.069,1.069c0,0.603-0.485,1.068-1.069,1.068H40.55C39.869,33.552,39.344,33.028,39.344,32.347z
            "
                    />
                    <path
                        fill="#222324"
                        d="M52.731,21.075c0-0.662,0.524-1.206,1.205-1.206h0.252c0.525,0,0.875,0.272,1.108,0.642l4.121,6.454
            l4.139-6.473c0.253-0.408,0.603-0.623,1.089-0.623h0.252c0.681,0,1.206,0.544,1.206,1.206v11.389c0,0.661-0.524,1.186-1.206,1.186
            c-0.642,0-1.186-0.544-1.186-1.186v-8.163l-3.323,4.996c-0.253,0.388-0.564,0.621-1.011,0.621c-0.428,0-0.739-0.233-0.992-0.621
            l-3.304-4.958v8.146c0,0.66-0.525,1.165-1.187,1.165c-0.66,0-1.165-0.505-1.165-1.165V21.075z"
                    />
                    <path
                        fill="#222324"
                        d="M69.725,26.788V26.75c0-3.866,2.896-7.036,7.016-7.036c2.1,0,3.479,0.623,4.665,1.535
            c0.253,0.195,0.466,0.525,0.466,0.952c0,0.662-0.524,1.167-1.186,1.167c-0.33,0-0.564-0.117-0.719-0.232
            c-0.933-0.759-1.944-1.225-3.246-1.225c-2.585,0-4.489,2.138-4.489,4.8v0.039c0,2.664,1.886,4.819,4.489,4.819
            c1.438,0,2.41-0.465,3.4-1.301c0.176-0.156,0.429-0.272,0.722-0.272c0.601,0,1.126,0.505,1.126,1.108
            c0,0.368-0.175,0.659-0.389,0.854c-1.283,1.128-2.74,1.827-4.937,1.827C72.678,33.786,69.725,30.696,69.725,26.788z"
                    />
                    <path
                        fill="#222324"
                        d="M84.258,31.997l5.054-11.272c0.271-0.603,0.759-0.972,1.438-0.972h0.116c0.682,0,1.147,0.369,1.42,0.972
            l5.054,11.272c0.097,0.176,0.135,0.351,0.135,0.507c0,0.641-0.485,1.146-1.127,1.146c-0.563,0-0.952-0.33-1.167-0.836
            l-1.105-2.545h-6.61l-1.145,2.623c-0.195,0.485-0.604,0.758-1.108,0.758c-0.623,0-1.107-0.486-1.107-1.108
            C84.103,32.367,84.16,32.193,84.258,31.997z M93.16,28.149l-2.392-5.501l-2.39,5.501H93.16z"
                    />
                    <path
                        fill="#222324"
                        d="M100.281,32.036c-0.272-0.194-0.468-0.524-0.468-0.912c0-0.623,0.507-1.108,1.128-1.108
            c0.33,0,0.544,0.097,0.7,0.214c1.127,0.895,2.331,1.398,3.81,1.398c1.477,0,2.408-0.7,2.408-1.71v-0.04
            c0-0.97-0.543-1.494-3.07-2.077c-2.895-0.702-4.528-1.557-4.528-4.063v-0.039c0-2.332,1.944-3.945,4.646-3.945
            c1.711,0,3.091,0.446,4.314,1.264c0.272,0.155,0.525,0.485,0.525,0.952c0,0.623-0.506,1.108-1.127,1.108
            c-0.234,0-0.429-0.058-0.622-0.176c-1.049-0.68-2.062-1.03-3.13-1.03c-1.398,0-2.216,0.721-2.216,1.613v0.039
            c0,1.05,0.623,1.517,3.245,2.139c2.877,0.699,4.355,1.729,4.355,3.983v0.039c0,2.547-2.002,4.063-4.859,4.063
            C103.546,33.747,101.796,33.163,100.281,32.036z"
                    />
                    <path
                        fill="#222324"
                        d="M112.137,31.997l5.053-11.272c0.273-0.603,0.759-0.972,1.439-0.972h0.116c0.681,0,1.146,0.369,1.419,0.972
            l5.054,11.272c0.096,0.176,0.136,0.351,0.136,0.507c0,0.641-0.487,1.146-1.128,1.146c-0.563,0-0.952-0.33-1.167-0.836
            l-1.107-2.545h-6.607l-1.146,2.623c-0.195,0.485-0.604,0.758-1.108,0.758c-0.622,0-1.108-0.486-1.108-1.108
            C111.982,32.367,112.041,32.193,112.137,31.997z M121.04,28.149l-2.39-5.501l-2.392,5.501H121.04z"
                    />
                </g>
            </g>
        </svg>
    );
};

export default CecaPt;
